import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { CadsKeyValueListConfig } from './cads-key-value-list.config';

/**
 * **Key-value list:** vertical stack of horizontal label/value rows with optional dividers. No surface of its own—place
 * inside {@link CadsCardViewComponent} (e.g. transfer review, confirmation summaries).
 */
@Component({
  selector: 'cads-key-value-list',
  imports: [],
  templateUrl: './cads-key-value-list.component.html',
  styleUrl: './cads-key-value-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadsKeyValueListComponent {
  readonly config = input.required<CadsKeyValueListConfig>();

  private readonly _showDividers = computed(() => this.config().showDividers !== false);

  protected _showDividerAfter(index: number): boolean {
    if (!this._showDividers()) {
      return false;
    }
    return index < this.config().rows.length - 1;
  }
}
